import { render } from "./os.vue?vue&type=template&id=00c23069&scoped=true"
import script from "./os.vue?vue&type=script&lang=js"
export * from "./os.vue?vue&type=script&lang=js"

import "./os.vue?vue&type=style&index=0&id=00c23069&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/official-accounts/official-accounts/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c23069"]])

export default __exports__